import Joi from '@hapi/joi'

export const DeductionSummaryReportSchema = {
    groupID: Joi.number().invalid(0).required().label("Group").messages({
        "any.invalid": `Select group`,
        "any.required": `Group required`
    }),
    operationEntityID: Joi.number().invalid(0).required().label("Estate").messages({
        "any.invalid": `Select Estate`,
        "any.required": `Estate required`
    }),
    collectionPointID: Joi.number().invalid(0).label("Division").messages({
        "any.invalid": `Select Division`,
        "any.required": `Division required`
    }),
    searchDate: Joi.string().invalid("").required().label("Date").messages({
        "any.invalid": `Date required`,
    })
}